import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "../me/index.js";
import { RueckfrageGastgeber } from "./VerwerfenRueckfrage.js";
import { StrikteEbene, useElternHuelle, useStrikteWege } from "./strikteHuelle.js";
import "./Modal.css";
/** Die vier Stufen in Pixeln des Entwurfs — `me-dialog` rechnet sie selbst in rem um. */
const BREITE_PX = {
    standard: 480,
    mittel: 640,
    breit: 900,
    weit: 1200,
};
/**
 * Passen Eltern-Maske und Subdialog NEBENEINANDER ins Fenster? Sonst `unter="stapel"`.
 *
 * Seitlich (Entscheid Dirk 14) legt me-dialog den Subdialog links neben die Eltern-Maske und
 * hält dafür deren volle Breite frei. Bei einer weiten Maske (1200) und einem Subdialog
 * (480) auf einem 1280er Fenster läge der Subdialog dann ausserhalb des Bildes (E2E
 * beleg-pdf: „element is outside of the viewport"). Das Element weicht nicht selbst aus
 * (Lücke an me-design gemeldet); bis dahin entscheidet die Hülle beim Öffnen. Die Breiten
 * sind Pixel des Entwurfs auf 13px-Grundschrift — umgerechnet mit der Grundschrift der
 * Seite, wie das Element es in rem tut.
 */
function passtNebeneinander(elternPx, eigenePx) {
    if (typeof window === "undefined")
        return true;
    const grund = Number.parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
    return (elternPx + eigenePx) * (grund / 13) <= window.innerWidth;
}
export function Modal(p) {
    const eltern = useElternHuelle();
    const breitePx = BREITE_PX[p.breite ?? "standard"];
    /*
     * Die Wege hinaus (Riegel am Rahmen, natives Schliessen abgefangen, Öffnen im selben
     * Commit) und die Fokus-Rückgabe an den Auslöser stehen seit dem Paket
     * „Editor-Arbeitsdialog“ (09.10.2026) gemeinsam mit dem `Arbeitsdialog` in
     * strikteHuelle.tsx — dort auch die Arbeitsteilung am Riegel.
     */
    const { anker, steuerung } = useStrikteWege(p);
    /*
     * `strikt`: Ein Klick auf den Schleier schliesst NICHT (das Element prüft das selbst).
     * `offen` bleibt fest auf true — das Modal ist offen, solange es eingehängt ist.
     * Die Klasse `ki-modal` am Host ist nur Kennzeichen (die Einklapp-Regel der Verwaltung
     * nimmt ihn aus, Verwaltung.css); die Optik kommt vom Element.
     * `aria-label` = Titel, zusätzlich zum `aria-labelledby` des Elements: Das Element reicht
     * es an seine Ebene durch. Nicht jede Namensberechnung folgt dem Verweis auf die
     * Überschrift im Schatten samt Slot (Playwright fand den Dialog namenlos); bei
     * gefülltem Titel sticht `aria-labelledby` das Label ohnehin aus.
     * Im Inhalt einer anderen Hülle wird das Modal per Portal an <body> gezeichnet
     * (`StrikteEbene`, Review K1/K2).
     */
    return (_jsx(StrikteEbene, { eltern: eltern, breitePx: breitePx, children: _jsxs(Dialog, { ref: steuerung, offen: true, strikt: true, lage: "rechts", breite: breitePx, unter: p.gestapelt === true
                || (eltern !== null && !passtNebeneinander(eltern.breitePx, breitePx))
                ? "stapel" : "seitlich", className: "ki-modal", "aria-label": p.titel, titel: _jsx("span", { ref: anker, children: p.titel }), children: [p.children, _jsx(RueckfrageGastgeber, {})] }) }));
}
/**
 * Die Fußleiste eines strikten Modals — Speichern links, Abbrechen rechts, in jeder Maske
 * dieselbe Reihenfolge und dieselben Wörter.
 *
 * Sie steht hier und nicht in jeder Maske abgeschrieben, weil sie die Hausregel TRÄGT:
 * Solange jede Maske ihre zwei Knöpfe selbst zeichnete, konnte eine davon ein drittes
 * „Schliessen" dazustellen.
 */
export function ModalFuss(p) {
    /*
     * `slot="fuss"`: Der Fuss liegt als Kind von `Modal` im Inhalt, und `me-dialog` verteilt
     * ihn in seine Fußzeile (klebend, nur der Inhalt rollt). Dafür muss `ModalFuss`
     * UNMITTELBARES Kind von `Modal` sein — so steht er in allen Masken. `display: contents`
     * macht die zwei Knöpfe selbst zu den Kindern der Knopfzeile des Elements.
     */
    return (_jsxs("div", { slot: "fuss", className: "ki-modal__aktionen", style: { display: "contents" }, children: [_jsx("button", { type: "button", className: "ki-modal__primaer", disabled: p.speichernGesperrt === true, ...(p.speichernLabel === undefined ? {} : { "aria-label": p.speichernLabel }), onClick: p.onSpeichern, children: p.speichernText }), p.nurSchliessen !== true && (_jsx("button", { type: "button", className: "ki-modal__knopf", disabled: p.abbrechenGesperrt === true, onClick: p.onAbbrechen, children: "Abbrechen" }))] }));
}
// Die Rückfrage vor dem Abbrechen steht seit ME-Etappe 3 als Subdialog in
// VerwerfenRueckfrage.tsx; der Name bleibt hier erreichbar.
export { darfAbbrechen } from "./VerwerfenRueckfrage.js";
//# sourceMappingURL=Modal.js.map